// extracted by mini-css-extract-plugin
module.exports = {"component":"my-profile-button_component_NIJgq","image":"my-profile-button_image_1T51c","name":"my-profile-button_name_16x76","username":"my-profile-button_username_1P7pN"};